import { ReactChild, ReactChildren, ReactNode } from 'react';
import { ScrollWrapper } from './styles';

interface Props {
  children?: ReactChild | ReactChildren | ReactNode;
}
const HorizontalScroll = ({ children }: Props) => <ScrollWrapper>{children}</ScrollWrapper>;

export default HorizontalScroll;
